import {Link } from "react-router-dom";
import industryData from "../../Database/industry_experience.json";
import "./index.css"
import MetaTags from "../../../components/MetaTags";
export default function IndustryHome() {
    const ExpDataArray = industryData.IndustryExpData
    const moment = require('moment');
    return(
        <>
            <MetaTags   title="Experience"
                        description="I’m a Data Scientist with 4+ years of hands-on experience designing, deploying, and optimizing machine learning solutions with a focus on anomaly detection, time series modeling, and probabilistic reasoning."
                        />
        <div className="justify-content-center pb-4" id="wd-industry-home">
            <div>
            <h1 id="wd-industry-title">Professional Experience </h1> <hr/>
            </div>
            <p> I’m a Data Scientist with 4+ years of hands-on experience designing, deploying, and optimizing machine learning solutions with a focus on anomaly detection, time series modeling, and probabilistic reasoning.</p>
            <h2 is="wd-industry-published">  Experience ({ExpDataArray.length}) </h2> <hr/>

            <div id="wd-industry-projects" className="row ms-4">
            <div className="row justify-content-center row-cols-1 row-cols-md-5 row-cols-g-4 gy-3">
                
            {ExpDataArray.map( (experience) => ( 
                <div className="wd-industry-project col" style={{width: "300px"}}>
                <Link to={`/industry/${experience._id}/Home`} className="text-decoration-none">
                <div  className="card rounded-3 overflow-hidden h-100">
                <img  className="card-img-top img-fluid" 
                        src={experience._principal_img} width={"160"} />
                <div className="card-body d-flex flex-column">
                    <span className="wd-industry-project-link"
                        style={{ textDecoration:"none", color:"navy", fontWeight: "bold"}}>
                            <strong>{experience._job_title} </strong>
                        </span>
                    <p className="card-text">
                    {experience._business}
                    </p>
                    <p className="card-text mt-auto"><small className="text-muted"> {moment(experience._date_from).format('MM/YYYY')} - {experience._date_to ? moment(experience._date_to).format('MM/YYYY') : 'Present'}</small></p>
                    <div className="btn-go mt-auto">
                        <Link to={`/industry/${experience._id}/Home`} className="btn btn-primary">Go</Link>
                    </div>
                </div>
                </div>
                </Link>
                </div>
            ))}

            </div>
            </div>
        </div>
        </>
    );
}